import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ClipboardTextBox.html?raw';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import { AccessibilityLabelsHelper } from "../../../more/Helpers";



class ClipboardTextBox extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: HTMLInputElement;
    labelNode: HTMLLabelElement;
    errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";

    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;

    _value: string;

    //private popoverContainerDiv:HTMLDivElement;
    private copyTextBtn: HTMLButtonElement;
    private checkIcon: HTMLElement;
    private copyTextBtnIcon: HTMLElement;
    focus() {
        this.inputNode.focus();
    }

    setValue(newValue: any, suppressChangeEvent: boolean = false): void {
        this._value = newValue;
        this.setInputValue(suppressChangeEvent);
    }

    protected setInputValue(suppressChangeEvent: boolean = false): void {
        this.inputNode.value = this._value;
        if (suppressChangeEvent == false) {
            this.emit("change", this._value);
        }
    }

    private _onClickFocus_InputContainer(ev: Event) {
        ev.stopPropagation();
        this.inputNode.select();
        this.emit("textSelected");
    }

    private _onClick_CopyBtn(ev: Event) {
        ev.stopPropagation();
        ev.preventDefault(); //wegen popover
        navigator.clipboard.writeText(this._value ? this._value : "");
        this.emit("copiedToClipboard");
        this.setConfirmedStyle(true);
    }

    private setConfirmedStyle(isConfirmed: boolean) {
        this.UiModder.domClass.toggle(this.copyTextBtn, "confirmed", isConfirmed);
        this.UiModder.domClass.toggle(this.checkIcon, "w3-hide", !isConfirmed);
        this.UiModder.domClass.toggle(this.copyTextBtnIcon, "w3-hide", isConfirmed);
        if (isConfirmed) {
            setTimeout(lang.hitch(this, this.setConfirmedStyle, false), 2000);
        }
    }

    public setAllDataCyAttributes() {
        super.setAllDataCyAttributes.apply(this, arguments as any);
        this.setDataCyAttribute(this.copyTextBtn, "copyTextBtn");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //id setzen fuer popoverContainerDiv
        let popoverID = this.id + "_popoverCopyText";
        //this.popoverContainerDiv.id = popoverID;
        this.copyTextBtn.setAttribute("popovertarget", popoverID);
        //wir setzen das popover attribute erst hier damit das element im container bleibt
        //mit anchors wird das dann einfacher in einem jahr
        //this.popoverContainerDiv.setAttribute("popover", "");

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "clipboardInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ClipboardTextBox);
